import React, { Component } from "react";
import {
  Button,
  Col,
  Drawer,
  Space,
  Select,
  message,
  Tag,
  Checkbox,
} from "antd";
import saturninoAvatar from "../../assets/img/nadubot/saturnino.png";

class FiltersDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [
        {
          label: "Bienvenido",
          value: "welcome",
        },
        {
          label: "Comercial",
          value: "commercial",
        },
        {
          label: "Técnico",
          value: "technician",
        },
        {
          label: "Facturación",
          value: "billing",
        },
      ],
    };
  }

  tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    let color = "";
    switch (value) {
      case "welcome":
        color = "green";
        break;
      case "commercial":
        color = "blue";
        break;
      case "technician":
        color = "gold";
        break;
      default:
        color = "default";
    }
    return (
      <Tag
        color={color}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 4 }}
      >
        {label}
      </Tag>
    );
  };

  render() {
    const { filters } = this.props;
    return (
      <Drawer title={"Filtros"} width={480} open={this.props.showDrawerModal} onClose={() => this.props.handleOpenDrawerModal(false)}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "400",
            color: "rgba(0, 0, 0, 0.88)",
            marginBottom: "6px",
            lineHeight: "1.5715",
          }}
        >
          Filtrar por tipo
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
            gap: "5px",
            paddingRight: "5px",
            paddingLeft: "5px",
            overflowX: "auto",
            scrollbarWidth: "thin",
            msOverflowStyle: "thin",
          }}
        >
          <Button
            shape="round"
            type={filters.selectedButton === "all" && "primary"}
            onClick={() =>
              this.props.handleFiltersChange({ selectedButton: "all" })
            }
          >
            Todos
          </Button>
          <div
            id={
              filters.selectedButton === "bot"
                ? "nadubot-custom-btn-selected"
                : "nadubot-custom-btn"
            }
            onClick={() =>
              this.props.handleFiltersChange({ selectedButton: "bot" })
            }
          >
            <img src={saturninoAvatar} alt="" />
          </div>
          <Button
            shape="round"
            type={filters.selectedButton === "toManage" && "primary"}
            onClick={() =>
              this.props.handleFiltersChange({ selectedButton: "toManage" })
            }
          >
            Por gestionar
          </Button>
          <Button
            shape="round"
            type={filters.selectedButton === "managed" && "primary"}
            onClick={() =>
              this.props.handleFiltersChange({ selectedButton: "managed" })
            }
          >
            Gestionados
          </Button>
        </div>
        <Col span={24}>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "400",
              color: "rgba(0, 0, 0, 0.88)",
              marginBottom: "6px",
              lineHeight: "1.5715",
            }}
          >
            Filtrar por departamentos
          </div>
          <Select
            name="departments"
            placeholder="Seleccionar departamentos"
            allowClear
            value={filters.departments}
            mode="multiple"
            tagRender={this.tagRender}
            options={this.state.departments}
            style={{ width: "100%", marginBottom: "8px" }}
            onChange={(values) =>
              this.props.handleFiltersChange({
                departments: values,
              })
            }
          />
        </Col>
        <Col span={24} style={{ marginBottom: "24px" }}>
          <Checkbox
            checked={filters.onlyCurrentUser}
            onChange={() =>
              this.props.handleFiltersChange({
                onlyCurrentUser:
                  filters.onlyCurrentUser.length === 0
                    ? this.props.employee_id
                    : "",
              })
            }
          >
            Filtrar por solo mis clientes
          </Checkbox>
        </Col>

        <Space>
          <Button onClick={() => this.props.handleOpenDrawerModal(false)}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              this.props.loadData();
              this.props.handleOpenDrawerModal(false);
            }}
            type="primary"
            disabled={!filters.departments.length > 0}
          >
            Aplicar filtros
          </Button>
        </Space>
      </Drawer>
    );
  }
}

export default FiltersDrawer;



// WEBPACK FOOTER //
// ./src/views/NaduChat/FiltersDrawer.jsx